/* Freezbone shop menu (Sep 2026). Desktop: category row opens a drop-down panel. Phone/tablet: full-height drawer. */
(function () {
  var root = document.querySelector('[data-fzm]');
  if (!root || root.dataset.fzmReady) return;
  root.dataset.fzmReady = '1';

  var store = root.querySelector('[data-fzm-store]');
  var megaBody = root.querySelector('[data-fzm-mega-body]');
  var subBody = root.querySelector('[data-fzm-sub-body]');
  var subTitle = root.querySelector('[data-fzm-sub-title]');
  var subAll = root.querySelector('[data-fzm-sub-all]');
  var burger = document.querySelector('[data-fzm-burger]');
  var catBtns = root.querySelectorAll('[data-fzm-cat]');
  var desktop = window.matchMedia('(min-width: 990px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var current = null, hoverT, leaveT;

  /* while the menu is open, lift the whole header section above everything on the page
     (collection cards, quick-add buttons and other positioned elements would otherwise show through) */
  var hdrSec = root.closest('.shopify-section') || root.closest('.section-header');
  function front(on) { if (hdrSec) hdrSec.classList.toggle('fzm-front', on); }
  function panel(id) { return root.querySelector('[data-fzm-panel="' + id + '"]'); }
  function setTop() {
    var hdr = document.querySelector('.section-header') || root;
    var el = desktop.matches ? root.querySelector('.fzm-row') : hdr;
    var b = Math.max(0, Math.round((el || hdr).getBoundingClientRect().bottom));
    root.style.setProperty('--fzm-top', b + 'px');
  }
  function showGroup(p, i) {
    p.querySelectorAll('[data-fzm-group]').forEach(function (g) { g.classList.toggle('is-active', g.dataset.fzmGroup == i); });
    p.querySelectorAll('[data-fzm-tab]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.fzmTab == i); });
  }

  /* ---------- desktop ---------- */
  function openMega(id) {
    var p = panel(id); if (!p) return;
    if (current !== id) {
      Array.prototype.forEach.call(megaBody.children, function (c) { store.appendChild(c); });
      megaBody.appendChild(p);
      showGroup(p, 0);
      current = id;
    }
    catBtns.forEach(function (b) { b.setAttribute('aria-expanded', b.dataset.fzmCat === id ? 'true' : 'false'); });
    setTop();
    front(true);
    root.classList.add('is-open');
  }
  function closeMega() {
    root.classList.remove('is-open');
    front(false);
    catBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  catBtns.forEach(function (b) {
    b.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(leaveT); clearTimeout(hoverT);
      hoverT = setTimeout(function () { openMega(b.dataset.fzmCat); }, root.classList.contains('is-open') ? 60 : 150);
    });
    b.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
    b.addEventListener('click', function (e) {
      clearTimeout(hoverT);
      /* Sep 30 2026 (Dan): on desktop with a mouse, hover opens the panel and a click goes to the category's own page.
         Touch screens (tablets at desktop width) and phones keep the old tap-to-open. */
      if (desktop.matches && finePointer.matches) {
        var p = root.querySelector('[data-fzm-panel="' + b.dataset.fzmCat + '"]'), u = p && p.getAttribute('data-url');
        if (u) { if (e.metaKey || e.ctrlKey) window.open(u, '_blank'); else location.href = u; return; }
      }
      if (root.classList.contains('is-open') && current === b.dataset.fzmCat) closeMega(); else openMega(b.dataset.fzmCat);
    });
  });
  megaBody.addEventListener('mouseover', function (e) {
    var t = e.target.closest('[data-fzm-tab]'); if (!t) return;
    showGroup(t.closest('[data-fzm-panel]'), t.dataset.fzmTab);
  });
  megaBody.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fzm-tab]'); if (!t) return;
    showGroup(t.closest('[data-fzm-panel]'), t.dataset.fzmTab);
  });
  var hoverZone = document.querySelector('.header-wrapper') || root;
  hoverZone.addEventListener('mouseleave', function () {
    if (!desktop.matches) return;
    clearTimeout(hoverT); leaveT = setTimeout(closeMega, 250);
  });
  hoverZone.addEventListener('mouseenter', function () { clearTimeout(leaveT); });
  root.querySelector('[data-fzm-scrim]').addEventListener('click', closeMega);

  /* ---------- phone / tablet ---------- */
  function openDrawer() {
    setTop();
    front(true);
    root.classList.add('is-open');
    document.documentElement.classList.add('fzm-lock');
    if (burger) burger.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    root.classList.remove('is-open', 'sub-open');
    front(false);
    document.documentElement.classList.remove('fzm-lock');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  function openSub(id) {
    var p = panel(id); if (!p) return;
    Array.prototype.forEach.call(subBody.children, function (c) { store.appendChild(c); });
    if (current === id) { Array.prototype.forEach.call(megaBody.children, function (c) { store.appendChild(c); }); current = null; }
    subBody.appendChild(p);
    subTitle.textContent = p.dataset.title;
    subAll.href = p.dataset.url;
    root.querySelector('[data-fzm-sub]').scrollTop = 0;
    root.classList.add('sub-open');
  }
  if (burger) burger.addEventListener('click', function () {
    root.classList.contains('is-open') ? closeDrawer() : openDrawer();
  });
  root.querySelectorAll('[data-fzm-open]').forEach(function (r) {
    r.addEventListener('click', function () { openSub(r.dataset.fzmOpen); });
  });
  root.querySelector('[data-fzm-back]').addEventListener('click', function () { root.classList.remove('sub-open'); });
  var dclose = root.querySelector('[data-fzm-dclose]'); if (dclose) dclose.addEventListener('click', closeDrawer);
  document.addEventListener('fzcart:open', function () { if (!desktop.matches) closeDrawer(); }); // the cart opens over the menu: close the menu

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
    if (desktop.matches) closeMega(); else if (root.classList.contains('sub-open')) root.classList.remove('sub-open'); else closeDrawer();
  });
  desktop.addEventListener('change', function () { closeMega(); closeDrawer(); });
  window.addEventListener('resize', function () { if (root.classList.contains('is-open')) setTop(); });

  /* --fzm-hb = where the visible header ends right now. Page builders (Build a Bundle, recipes, quiz) pin their tab bar there
     instead of at a fixed 60-106px, so the two never overlap while the header shrinks or grows. */
  (function () {
    if (!hdrSec) return;
    var de = document.documentElement, last = -1, raf = 0;
    function hb() { raf = 0; var b = Math.max(0, Math.round(hdrSec.getBoundingClientRect().bottom)); if (b !== last) { last = b; de.style.setProperty('--fzm-hb', b + 'px'); } }
    function soon() { if (!raf) raf = requestAnimationFrame(hb); }
    hb();
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    window.addEventListener('load', soon);
    hdrSec.addEventListener('transitionend', soon);
    hdrSec.addEventListener('transitionrun', function () { var t0 = performance.now(); (function loop() { hb(); if (performance.now() - t0 < 400) requestAnimationFrame(loop); })(); });
  })();

  /* desktop: scrolling down leaves only the category row pinned; scrolling up shows the whole header again */
  (function () {
    var sec = hdrSec, logoRow = document.querySelector('header.header'), catRow = root.querySelector('.fzm-row');
    if (!sec || !logoRow) return;
    var lastY = window.scrollY, ticking = false;
    // slide by everything above the category row (UK/EU also have an offer strip inside the header, not just the logo row)
    function hRow() {
      var d = catRow ? Math.round(catRow.getBoundingClientRect().top - sec.getBoundingClientRect().top) : logoRow.offsetHeight;
      sec.style.setProperty('--fzm-hrow', (d > 0 ? d : logoRow.offsetHeight) + 'px');
    }
    function update() {
      ticking = false;
      var y = window.scrollY, dy = y - lastY;
      if (!desktop.matches) { lastY = y; return; }
      var above = 0; for (var e = sec.previousElementSibling; e; e = e.previousElementSibling) above += e.offsetHeight || 0;
      var start = above + sec.offsetHeight;                  // only after the full header has scrolled past (offsetTop is unreliable while stuck)
      if (y <= start) { sec.classList.remove('fzm-compact'); lastY = y; return; }
      if (root.classList.contains('is-open')) { lastY = y; return; }
      if (y <= start) sec.classList.remove('fzm-compact');
      else if (dy > 6) sec.classList.add('fzm-compact');
      else if (dy < -6) sec.classList.remove('fzm-compact');
      if (Math.abs(dy) > 6 || y <= start) lastY = y;
    }
    hRow();
    window.addEventListener('resize', hRow);
    window.addEventListener('load', hRow);
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    desktop.addEventListener('change', function () { if (!desktop.matches) sec.classList.remove('fzm-compact'); });
  })();

  /* test hook: ?fzm=<category title> opens that category on load (used for screenshots) */
  var q = new URLSearchParams(location.search).get('fzm');
  if (q) {
    var want = q.toLowerCase(), id = null;
    root.querySelectorAll('[data-fzm-panel]').forEach(function (p) { if (!id && p.dataset.title.toLowerCase() === want) id = p.dataset.fzmPanel; });
    if (desktop.matches) { if (id) openMega(id); }
    else { openDrawer(); if (id) openSub(id); }
  }
})();
